import { Link } from 'react-router';
import { Blocks } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePermissions } from '@/hooks/use-permissions';
import { CUSTOM_TOOLS_PATH } from './paths';

/** The way in from the Integrations page, for those who may edit integrations. */
export const CustomToolsLink = () => {
	const { can } = usePermissions();
	if (!can('edit', 'integrations')) return null;
	return (
		<Button variant='outline' size='sm' className='h-8 rounded-full border-gray-500 text-xs font-normal' asChild>
			<Link to={CUSTOM_TOOLS_PATH}>
				<Blocks className='size-3.5' />
				Custom tools
			</Link>
		</Button>
	);
};
